import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'app-editstatuspopup',
    templateUrl: './editstatuspopup.component.html',
    styleUrls: ['./editstatuspopup.component.scss'],
})
export class EditstatuspopupComponent {
    constructor(@Inject(MAT_DIALOG_DATA) public data: any) {}

    ngOnInit() {
        console.log('User ID:', this.data.userId);
    }
}
